import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { UserService } from 'app/core/user/user.service';
import { Observable, ReplaySubject, tap } from 'rxjs';

// Navigation group IDs visible to OPS (role 8)
const OPS_VISIBLE_GROUPS = ['operations', 'resources'];

@Injectable({providedIn: 'root'})
export class NavigationService
{
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    constructor(
        private _httpClient: HttpClient,
        private _userService: UserService,
    )
    {
    }

    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    get(): Observable<Navigation>
    {
        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            tap((navigation) =>
            {
                const filtered = this._filterByRole(navigation);
                this._navigation.next(filtered);
            }),
        );
    }

    private _filterByRole(navigation: Navigation): Navigation
    {
        const user = this._userService.currentUser;
        // transformUser returns roles as string array: ['ADMIN', 'OPCLAC_OPS', ...]
        const roles: string[] = (user as any)?.roles || [];
        if (!roles.length) {
            return navigation;
        }

        // ADMIN and OPCLAC_ADMIN see everything
        if (roles.includes('ADMIN') || roles.includes('OPCLAC_ADMIN')) {
            return navigation;
        }

        // OPS only sees specific groups
        const filterItems = (items: FuseNavigationItem[]): FuseNavigationItem[] =>
            items.filter((item) => OPS_VISIBLE_GROUPS.includes(item.id));

        return {
            compact: filterItems(navigation.compact),
            default: filterItems(navigation.default),
            futuristic: filterItems(navigation.futuristic),
            horizontal: filterItems(navigation.horizontal),
        };
    }
}
